import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { filterSentryEvent } from './sentryEventFilters';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  tracesSampleRate: 0.1,
  tracePropagationTargets: ["walkmore.move-club.co", /^\/api\//],
  beforeSend(event: Sentry.ErrorEvent): Sentry.ErrorEvent | null {
    return filterSentryEvent(event);
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);